import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslation } from 'react-i18next'
import { useUpdateDocument } from '@/hooks/api'
import type { Document } from '@/types'
import { editDocumentSchema, type EditDocumentFormValues } from './EditDocumentDialog.static'

interface UseEditDocumentDialogProps {
  document: Document
  onClose: () => void
}

export function useEditDocumentDialog({ document, onClose }: UseEditDocumentDialogProps) {
  const { t } = useTranslation('documents')
  const updateDocument = useUpdateDocument()

  const form = useForm<EditDocumentFormValues>({
    resolver: zodResolver(editDocumentSchema),
    defaultValues: {
      title: document.title,
      documentType: document.documentType,
      description: document.description ?? '',
      documentDate: document.documentDate ?? '',
    },
  })

  function handleSubmit(values: EditDocumentFormValues) {
    updateDocument.mutate(
      {
        id: document.id,
        data: {
          title: values.title,
          documentType: values.documentType as Document['documentType'],
          description: values.description || null,
          documentDate: values.documentDate || null,
        },
      },
      { onSuccess: onClose }
    )
  }

  return {
    t,
    form,
    handleSubmit: form.handleSubmit(handleSubmit),
    isLoading: updateDocument.isPending,
  }
}
